import React from 'react';
import PropTypes from 'prop-types';

import { Group } from '@vx/group';
import { AreaClosed, LinePath } from '@vx/shape';

const PriceLine = ({ margin, xScale, yScale, color, line, data, x, y }) => (
  <Group top={margin.top} left={margin.left}>
    <AreaClosed
      data={data}
      x={d => xScale(x(d))}
      y={d => yScale(y(d))}
      yScale={yScale}
      stroke="transparent"
      fill={color}
      fillOpacity={0.25}
    />

    <LinePath
      data={data}
      x={d => xScale(x(d))}
      y={d => yScale(y(d))}
      stroke={color}
      strokeWidth={2}
      strokeDasharray={line}
    />
  </Group>
);

PriceLine.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      date: PropTypes.string,
      value: PropTypes.number,
    })
  ).isRequired,
  margin: PropTypes.shape({
    top: PropTypes.number,
    left: PropTypes.number,
  }).isRequired,
  xScale: PropTypes.func.isRequired,
  yScale: PropTypes.func.isRequired,
  x: PropTypes.func.isRequired,
  y: PropTypes.func.isRequired,
  color: PropTypes.string.isRequired,
  line: PropTypes.string,
};

PriceLine.defaultProps = {
  line: '0',
};

export default PriceLine;
